
import React from 'react';
import PropTypes from 'prop-types';

import MediaCard from 'common/designer-modules/modules/media';
import ContentTagsFilter from 'common/designer-modules/modules/content-library/tags-filter';
import ContentSorting from 'common/designer-modules/modules/content-library/sorting';
import ContentFilters from 'common/designer-modules/modules/content-library/filters';
import { MediaTitile } from 'common/designer-modules/modules/media/modules';
import { useSiteGlobalSettingsHelper } from 'common/designer-modules/globalSettingsHelper';
import { getMediaIndividualPagePath } from 'common/designer-modules/siteDesigner';
import cx from 'classnames';
import Search from 'common/components/elements/inputs/search';
import Button from 'common/components/elements/buttons/primary';

const ContentLibrary = ({
   settings = {},
   type,
   data,
   isMobile,
   isFetching,
   globalSettings,
   onNextContent,
   isNextFetching,
   filters,
   onFilterChange,
   resources,
   hiddeClearFilters,
   clearAllFilters,
   showMorePaginationButton,
   contentLibraryRef,
   getTheHref,
   isNextApp,
}) => {
   const { getModifySectionGlobalSetting, getSitePrimaryColor } = useSiteGlobalSettingsHelper(globalSettings);
   const contentCardSettings = getModifySectionGlobalSetting('content_cards');
   const {
      title,
      description,
      alignment,
      content_card_size,
      options = [],
   } = settings
   const cardPropsProps = {
      type: type,
      cardSize: content_card_size,
      contentCardSettings: contentCardSettings,
      isNextApp: isNextApp,
   }
   const list = data?.data || [];
   const hasSorting = options.includes('sorting');
   const hasSearch = options.includes('search');
   const hasFilter = options.includes('filter');
   return (
      <div
         ref={ contentLibraryRef }
         className='flex flex-col gap-6 w-full px-6'>
         <MediaTitile
            title={ title }
            isMobile={ isMobile }
            total={ data?.total }
            type={ type }
            description={ description }
            alignment={ alignment }
            showContentCount={ options.includes('content_count') }
         />
         {
            (hasFilter || hasSorting || hasSearch) && (
               <div
                  className={ cx({
                     'flex gap-4': true,
                     'flex-col': isMobile,
                  }) }
               >
                  {
                     hasFilter && (
                        <div
                           className={ cx({
                              'flex flex-1 gap-2': true,
                              'overflow-x-auto': isMobile,
                           }) }
                        >
                           <ContentFilters
                              contentType={ type }
                              filters={ filters }
                              primaryColor={ getSitePrimaryColor() }
                              onFilterChange={ onFilterChange }
                              resources={ resources }
                              isMobile={ isMobile }
                              hiddeClearFilters={ hiddeClearFilters }
                              clearAllFilters={ clearAllFilters }
                           />
                        </div>
                     )
                  }
                  {
                     (hasSorting || hasSearch) && (
                        <div
                           className={ cx({
                              'flex gap-4 flex-1': true,
                              'flex-col': isMobile,
                              'justify-end': !isMobile,
                           }) }
                        >
                           {
                              hasSorting && (
                                 <div className='flex'>
                                    <ContentSorting
                                       onFilterChange={ (value) => onFilterChange('sortBy', value) }
                                       activeValue={ filters.sortBy }
                                       contentType={ type }
                                       isMobile={ isMobile }
                                       contentCardSettings={ contentCardSettings }
                                    />
                                 </div>

                              )
                           }
                           {
                              hasSearch && (
                                 <div className='flex'>
                                    <Search
                                       placeholder='Search'
                                       value={ filters?.search }
                                       onChange={ (value) => onFilterChange('search', value) }
                                    />
                                 </div>

                              )
                           }

                        </div>
                     )
                  }

               </div>
            )
         }
         {
            options.includes('content_tags') && ['video', 'photoset'].includes(type)  && (
               <ContentTagsFilter
                  tagsData={ resources?.tags || [] }
                  onChange={ (value) => onFilterChange('tags', value, true) }
                  selectedValue={ filters?.tags || [] }
                  primaryColor={ getSitePrimaryColor() }
                  isNextApp={ isNextApp }
               />
            )
         }
         {
            <div className='flex flex-wrap w-full gap-4'>
               {
                  !isFetching && !Boolean(list?.length) && (
                     <div className='min-h-24 flex items-center justify-center w-full'>
                        <span className='text-placeholder dark:text-placeholder-dark font-medium text-base'>No result</span>
                     </div>
                  )
               }

               {
                  !isFetching && Boolean(list?.length) && list.map(media => {
                     return (
                        <MediaCard
                           key={ media.id }
                           media={ media }
                           { ...cardPropsProps }
                           href={ getMediaIndividualPagePath(getTheHref, media) }
                        />
                     )
                  })
               }
               {
                  (isFetching || isNextFetching) && (
                     <>
                        <MediaCard
                           isLoading
                           { ...cardPropsProps }
                        />
                        <MediaCard
                           isLoading
                           { ...cardPropsProps }
                        />
                        <MediaCard
                           isLoading
                           { ...cardPropsProps }
                        />
                     </>
                  )
               }
               {
                  showMorePaginationButton && (
                     <Button
                        text='MOre'
                        onClick={ onNextContent }
                        disabled={ isNextFetching }
                     />
                  )
               }
            </div>
         }
      </div>
   );
}
ContentLibrary.propTypes = {
   settings: PropTypes.object,
   globalSettings: PropTypes.object,
   type: PropTypes.oneOf([
      'video', 'story', 'store', 'recorded_stream', 'photoset',
   ]),
   data: PropTypes.object,
   isMobile: PropTypes.bool,
   isFetching: PropTypes.bool,
   onNextContent: PropTypes.bool,
   isNextFetching: PropTypes.bool,
   hiddeClearFilters: PropTypes.bool,
   onFilterChange: PropTypes.func,
   clearAllFilters: PropTypes.func,
   getTheHref: PropTypes.func,
   filters: PropTypes.object,
   resources: PropTypes.object,
   showMorePaginationButton: PropTypes.bool,
   isNextApp: PropTypes.bool,
   contentLibraryRef: PropTypes.any,
};

export default ContentLibrary;


